/* ==========================================================================
   LINDIE — AJAX Cart + Cart Drawer
   ========================================================================== */
(function () {
  'use strict';

  if (!window.lindieAjaxCart) return;

  /* ── Money formatting ──────────────────────────────────────────────────── */
  function formatMoney(cents) {
    var fmt = window.lindieMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDecimals = String(Math.floor(cents / 100));
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── DOM refs ──────────────────────────────────────────────────────────── */
  var overlay  = document.getElementById('LindieCartOverlay');
  var drawer   = document.getElementById('LindieCartDrawer');
  var body     = document.getElementById('LindieCartBody');
  var footer   = document.getElementById('LindieCartFooter');
  var countEl  = document.getElementById('LindieCartDrawerCount');
  var subtotal = document.getElementById('LindieCartSubtotal');
  var closeBtn = document.getElementById('LindieCartClose');
  var badge    = document.querySelector('.js-cart-badge');

  if (!drawer) return;

  /* ── Drawer open / close ───────────────────────────────────────────────── */
  function openDrawer() {
    drawer.classList.add('lindie-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('lindie-cart-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('lindie-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('lindie-cart-overlay--open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('lindie-cart-drawer--open')) closeDrawer();
  });

  /* ── Cart icon in header opens drawer ─────────────────────────────────── */
  var cartIconLink = document.querySelector('.js-cart-icon');
  if (cartIconLink) {
    cartIconLink.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  /* ── Badge + count sync ────────────────────────────────────────────────── */
  function syncBadge(count) {
    if (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    }
    if (countEl) countEl.textContent = '(' + count + ')';
  }

  /* ── Render drawer body from cart data ─────────────────────────────────── */
  function renderBody(cart) {
    syncBadge(cart.item_count);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    if (cart.items.length === 0) {
      if (footer) footer.style.display = 'none';
      body.innerHTML =
        '<div class="lindie-cart-drawer__empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p class="lindie-cart-drawer__empty-title">Your cart is empty</p>' +
          '<p class="lindie-cart-drawer__empty-text">Browse our audiobook collection to find your next great listen.</p>' +
          '<a href="/collections/all" class="lindie-cart-drawer__empty-btn">Browse Audiobooks</a>' +
        '</div>';
      return;
    }

    if (footer) footer.style.display = 'flex';

    var html = '<ul class="lindie-cart-drawer__items">';
    cart.items.forEach(function (item) {
      var imgUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace('?', '?width=160&')
        : '';
      var imgTag = imgUrl
        ? '<img src="' + escHtml(imgUrl) + '" alt="' + escHtml(item.title) + '" class="lindie-cart-drawer__item-image" width="80" height="80" loading="lazy">'
        : '';
      var compareHtml = item.original_price > item.final_price
        ? '<span class="lindie-cart-drawer__item-compare">' + formatMoney(item.original_price) + '</span>'
        : '';
      var authorHtml = item.vendor
        ? '<p class="lindie-cart-drawer__item-author">by ' + escHtml(item.vendor) + '</p>'
        : '';

      html +=
        '<li class="lindie-cart-drawer__item" data-key="' + escHtml(item.key) + '">' +
          '<a href="' + escHtml(item.url) + '" class="lindie-cart-drawer__item-image-link">' + imgTag + '</a>' +
          '<div class="lindie-cart-drawer__item-info">' +
            '<a href="' + escHtml(item.url) + '" class="lindie-cart-drawer__item-title">' + escHtml(item.title) + '</a>' +
            authorHtml +
            '<div class="lindie-cart-drawer__item-price-row">' +
              '<span class="lindie-cart-drawer__item-price">' + formatMoney(item.final_price) + '</span>' +
              compareHtml +
            '</div>' +
            '<div class="lindie-cart-drawer__item-actions">' +
              '<div class="lindie-cart-drawer__item-qty">' +
                '<button class="lindie-cart-drawer__item-qty-btn js-lindie-qty-dec" data-key="' + escHtml(item.key) + '" aria-label="Decrease quantity">&#x2212;</button>' +
                '<span class="lindie-cart-drawer__item-qty-value">' + item.quantity + '</span>' +
                '<button class="lindie-cart-drawer__item-qty-btn js-lindie-qty-inc" data-key="' + escHtml(item.key) + '" aria-label="Increase quantity">&#x2B;</button>' +
              '</div>' +
              '<button class="lindie-cart-drawer__item-remove js-lindie-remove" data-key="' + escHtml(item.key) + '" aria-label="Remove ' + escHtml(item.title) + '">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    bindItemEvents();
  }

  /* ── Cart API helpers ──────────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ── Item event binding (called after each re-render) ──────────────────── */
  function bindItemEvents() {
    body.querySelectorAll('.js-lindie-qty-dec').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qtyEl = btn.closest('.lindie-cart-drawer__item-qty').querySelector('.lindie-cart-drawer__item-qty-value');
        var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        cartChange(key, Math.max(0, current - 1)).then(renderBody);
      });
    });

    body.querySelectorAll('.js-lindie-qty-inc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qtyEl = btn.closest('.lindie-cart-drawer__item-qty').querySelector('.lindie-cart-drawer__item-qty-value');
        var current = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
        cartChange(key, current + 1).then(renderBody);
      });
    });

    body.querySelectorAll('.js-lindie-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        cartChange(btn.dataset.key, 0).then(renderBody);
      });
    });
  }

  /* ── Add to cart interception ──────────────────────────────────────────── */
  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('lindie-atc--loading');
      btn.setAttribute('disabled', '');
    } else {
      btn.classList.remove('lindie-atc--loading');
      btn.removeAttribute('disabled');
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-lindie-atc]')) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('[type="submit"]');
    var variantId = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!variantId) return;

    setButtonLoading(btn, true);

    // Build the JSON payload explicitly — avoids URLSearchParams bracket-encoding issues
    var qty = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
    var properties = {};
    form.querySelectorAll('input[name^="properties["]').forEach(function(input) {
      if (!input.value) return;
      var key = input.name.slice('properties['.length, -1);
      properties[key] = input.value;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId.value, 10),
        quantity: qty,
        properties: Object.keys(properties).length ? properties : undefined,
      })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Add failed'); });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderBody(cart);
        openDrawer();
      })
      .catch(function (err) {
        console.error('LINDIE cart:', err.message);
      })
      .finally(function () {
        setButtonLoading(btn, false);
      });
  }, true /* capture — fires before product-form.js */);

  /* ── Init: bind existing item events on page load ──────────────────────── */
  bindItemEvents();

})();
